var map = {
	"./app/dashboard/shared/locales/it.json": "1f79",
	"./app/eventCategories/shared/locales/it.json": "d441",
	"./app/events/shared/locales/it.json": "5b06",
	"./app/frontends/shared/locales/it.json": "b649",
	"./app/options/shared/locales/it.json": "1559",
	"./app/roles/locales/it.json": "3eee",
	"./app/users/locales/it.json": "e409",
	"./app/weekPrograms/shared/locales/it.json": "b05a",
	"./locales/it.json": "0825"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80b2";